import { TransitionLoadingIndicator } from '@ui-common/components/TransitionLoadingIndicator'
import { useChangingText } from '@ui-common/utils'
import { mainContentAttributes } from '@ui-components/global/CommonStyling'
import { LogoIconType } from '@ui-components/global/ComponentProps'
import { PrimaryTopBar } from '@ui-components/navigation/PrimaryTopBar'
import { PAGE_EXIT_BUTTON_CLASS } from '@ui-components/utilities/helpers'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const Content = styled.section.attrs(mainContentAttributes)`
  margin: auto;
  padding: 0 16px;
  text-align: center;
  padding-top: 104px;
`

export const SendView = ({
  sendingHeader,
  sendingDescription,
  delayedSendingHeader,
  delayedSendingDescription,
  onAbort,
}: {
  sendingHeader: string
  sendingDescription: string
  delayedSendingHeader?: string
  delayedSendingDescription?: string
  onAbort: () => void
}) => {
  const intl = useIntl()
  const changingSendingHeader = useChangingText(sendingHeader, delayedSendingHeader ?? sendingHeader)
  const changingSendingDescription = useChangingText(
    sendingDescription,
    delayedSendingDescription ?? sendingDescription,
  )

  return (
    <>
      <PrimaryTopBar
        actionButtonOptions={{
          className: PAGE_EXIT_BUTTON_CLASS,
          label: intl.formatMessage({ id: 'common-exit' }),
          onClick: onAbort,
        }}
        icon={LogoIconType.SPankki}
        serviceName={intl.formatMessage({ id: 'common-sec-loans-site-header' })}
        variant="large"
      />
      <Content>
        <TransitionLoadingIndicator
          aria-live="polite"
          heading={changingSendingHeader}
          text={changingSendingDescription}
        />
      </Content>
    </>
  )
}
